import type { ConfigurableServer, Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useMetaModelContext } from '../../../context/metaModelContext'
import type { ConfigurationItemsByBlock } from '../../../workspace/operationsContext'
import type { IndexedRegisteredTenantCreateOperations } from '../../registeredTenantCreateOperations/types'
import { transformServerLayerTopologyToLayerKeys } from './helpers'
import { useFetchLayers } from './useFetchLayers'

export const useAllLayersOnServer = ({
  server,
  allTenants,
}: {
  server: Optional<ConfigurableServer>
  allTenants: Optional<
    ConfigurationItemsByBlock<IndexedRegisteredTenantCreateOperations>
  >
}) => {
  const { blockTopology } = useMetaModelContext()
  const { data: layers } = useFetchLayers(server)

  return useMemo(
    () =>
      transformServerLayerTopologyToLayerKeys({
        layers,
        allTenants,
        blockTopology,
      }),
    [layers, allTenants, blockTopology],
  )
}
